export { Card } from '@mantine/core'
